export default __webpack_public_path__ + "static/media/disabled-lab-icon.bcc06eab.svg";